import { render, staticRenderFns } from "./notification-item.vue?vue&type=template&id=20843dbc&scoped=true"
import script from "./notification-item.vue?vue&type=script&lang=js"
export * from "./notification-item.vue?vue&type=script&lang=js"
import style0 from "./notification-item.vue?vue&type=style&index=0&id=20843dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20843dbc",
  null
  
)

export default component.exports